import React from 'react';
import { getToken } from '../../helpers';
import { API, BEARER } from '../../constant';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import {
  Checkbox,
  Divider,
  Button,
  message,
  Form,
  Table,
  Typography,
  Col,
  Row,
  Spin,
  Select,
} from 'antd';

import { getUserDetails } from '../../helpers';
import { EditOutlined } from '@ant-design/icons';
import ListOfItem from '../ListOfItem/ListOfItem';
import { RollbackOutlined } from '@ant-design/icons';
import { render } from '@testing-library/react';
import { ProductDetailsViewLinkFactory } from '../../utils/ProductDetailsViewLink/ProductDetailsViewLinkFactory';
import { AllowedTeamWizeRolesConfig } from '../../utils/AccessRightHelper/AllowedTeamWizeRolesConfig';
import { PLMPhases } from '../../utils/PLMConfig/PLMPhases';

const { Text, Title } = Typography;

const CheckboxGroup = Checkbox.Group;
const plainOptions = ['SpecsSheet', 'MasterSheet', 'MetaSheet'];
const defaultCheckedList = ['SpecsSheet'];

const GenerateShopifyMasterSheet = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = getUserDetails();
  console.log(user, '48');

  const [searchParams, setSearchParams] = useSearchParams();

  const [genSpecsForm] = Form.useForm();
  const [editData, setEditData] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const [products, setProducts] = useState([]);
  const [filesCreatedList, setFilesCreatedList] = useState([]);
  const [pagination, setPagination] = useState(() => {
    const page = Number(searchParams.get('page') || '1');
    const pageSize = Number(searchParams.get('pageSize') || '10');

    return {
      current: Number.isFinite(page) && page > 0 ? page : 1,
      pageSize: Number.isFinite(pageSize) && pageSize > 0 ? pageSize : 10,
      total: 0,
    };
  });

  const [launchMastersList, setLaunchMastersList] = useState([]);
  const [selectedLaunch, setSelectedLaunch] = useState(
    searchParams?.get('launch') || null,
  );
  // const [selectedLaunchId,  ] = useState(searchParams?.get('launch') || '');
  console.log('generate specs sheet location', location.state);

  const allowedRoleCalculator = new AllowedTeamWizeRolesConfig();
  const teamWizeRoleEligibility = allowedRoleCalculator.createPermissions();

  const fetchLaunchList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API}/launch-masters?&populate[season][fields][0]=season_id&sort[0]=createdAt:desc`,
        {
          headers: { Authorization: `${BEARER} ${token}` },
        },
      );
      const optionsData = await response.json();

      optionsData2 = optionsData?.data?.map((entry) => {
        return {
          id: entry?.id,
          launchName: entry?.attributes?.launchName,
          launchDate: entry?.attributes?.launchDate,
          launchDrop: entry?.attributes?.launchDrop,
          launchCat: entry?.attributes?.launchCat,
          launchMonth: entry?.attributes?.launchMonth,

          seasonName: entry?.attributes?.season?.data?.attributes?.season_id,
        };
      });

      setLaunchMastersList(optionsData2);
      console.log('original Launch Master option  Data:', optionsData);
      console.log('modified Launch Master Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const launchListOption = launchMastersList.map((launch) => {
    return {
      label: `${launch.launchName} - ${launch.seasonName} `,
      value: launch.id,
    };
  });

  // launchListOption.unshift({ label: 'Select', value: null });

  const getAllProducts = async (launchId) => {
    const token = getToken();
    setIsLoading(true);
    // const data1 = [];
    try {
      const response = await fetch(
        `${API}/launch-masters/${launchId}?populate[core_products][populate][collection]=true&populate[core_products][populate][catalog_product][populate][shopify_product]=true&populate[core_products][populate][catalog_product][populate][channel]=true`,
        {
          headers: { Authorization: `${BEARER} ${token}` },
        },
      );
      const responseData = await response.json();
      console.log('original generate Data:', responseData);
      // return;

      const data1 = responseData?.data?.attributes?.core_products?.data
        ?.filter((coreProduct) => {
          console.log(
            coreProduct,
            'filter check',
            coreProduct?.attributes?.catalog_product?.data,
          );
          const catalogProduct = coreProduct?.attributes?.catalog_product?.data;
          if (catalogProduct) {
            return true;
          } else {
            return false;
          }
        })
        .map((coreProduct) => {
          console.log(coreProduct, 'product CHECK');
          return {
            id: coreProduct?.attributes?.catalog_product?.data?.id,
            cataloging_status:
              coreProduct?.attributes?.catalog_product?.data?.attributes
                ?.cataloging_status,
            master_sku: coreProduct?.attributes?.sku,
            collection:
              coreProduct?.attributes?.collection?.data?.attributes
                ?.collection_name,
            handle:
              coreProduct?.attributes?.catalog_product?.data?.attributes
                ?.shopify_product?.data?.attributes?.handle,
            title:
              coreProduct?.attributes?.catalog_product?.data?.attributes
                ?.shopify_product?.data?.attributes?.title,
            launch_name:
              coreProduct?.attributes?.catalog_product?.data?.attributes
                ?.shopify_product?.data?.attributes?.launch_name,
          };
        });
      console.log('original Data:', responseData);
      console.log('Data:', data1);

      const pageFromUrl = Number(searchParams.get('page') || '1');
      const pageSizeFromUrl = Number(searchParams.get('pageSize') || '10');
      const nextPagination = {
        current: Number.isFinite(pageFromUrl) && pageFromUrl > 0 ? pageFromUrl : 1,
        pageSize:
          Number.isFinite(pageSizeFromUrl) && pageSizeFromUrl > 0
            ? pageSizeFromUrl
            : 10,
        total: data1?.length || 0,
      };

      setProducts(data1);
      setPagination(nextPagination);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const GenerateSelectedSheets = async (list) => {
    console.log(list, selectedLaunch, 184);
    if (products.length > 0) {
      console.log(products, location.state);

      let productIdList = products.map((product) => product.id);
      let token = getToken();
      setIsLoading(true);
      console.log('product list', productIdList);
      // return false;
      try {
        const response = await fetch(
          `${API}/shopify-master-sheet-generate?launchId=${selectedLaunch}&productList=${productIdList}`,
          {
            headers: { Authorization: `${BEARER} ${token}` },
          },
        );
        const data = await response.json();
        console.log(data);
        // return false;
        setFilesCreatedList(data.data);
      } catch (error) {
        console.error(error);
        message.error('Something went wrong, Please try again later.');
      } finally {
        setIsLoading(false);
      }
    } else {
      message.error(
        'This launch Does not Have eligible products Please Try later!',
      );
    }
  };

  const syncPaginationToSearchParams = (nextPagination) => {
    const mergedPagination = {
      current: nextPagination.current || 1,
      pageSize: nextPagination.pageSize || 10,
      total: nextPagination.total ?? products.length,
    };

    setPagination(mergedPagination);

    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.set('page', String(mergedPagination.current));
    nextSearchParams.set('pageSize', String(mergedPagination.pageSize));

    if (selectedLaunch) {
      nextSearchParams.set('launch', selectedLaunch);
    } else {
      nextSearchParams.delete('launch');
    }

    setSearchParams(nextSearchParams);
  };

  const handleTableChange = (tablePagination) => {
    syncPaginationToSearchParams({
      current: tablePagination.current || 1,
      pageSize: tablePagination.pageSize || 10,
      total: products.length,
    });
  };

  const toProductDetails = (recordView) => {
    const { record } = recordView;
    const plmPhases = new PLMPhases();
    const userTeams = plmPhases.buildUserTeamsObject(user);

    const stage = plmPhases.getStageByUserTeams(userTeams); // TO DO: get stage based on user teams
    console.log('user teams identified :', userTeams, stage);
    const productDetailsView = ProductDetailsViewLinkFactory(stage);

    navigate(productDetailsView, {
      state: { ...record },
    });
  };

  const handleLaunchChange = (data) => {
    console.log('Launch change', data);
    setFilesCreatedList([]);
    setSelectedLaunch(data);
    setEditData({ ...editData, launchGen: data });

    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.set('launch', data);
    nextSearchParams.set('page', '1');
    nextSearchParams.set('pageSize', String(pagination.pageSize || 10));
    setSearchParams(nextSearchParams);
    setPagination({ current: 1, pageSize: pagination.pageSize || 10, total: 0 });
    // getAllProducts(data);
  };

  const resetSetting = () => {
    console.log('in Reset setting');
    setSelectedLaunch(null);
    setFilesCreatedList([]);
    setProducts([]);
    setEditData(null);
    setPagination({ current: 1, pageSize: 10, total: 0 });
    genSpecsForm.resetFields();

    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.delete('launch');
    nextSearchParams.delete('page');
    nextSearchParams.delete('pageSize');
    setSearchParams(nextSearchParams);
  };

  useEffect(() => {
    if (getToken()) {
      fetchLaunchList(getToken());
    }
  }, []);

  useEffect(() => {
    //dataform data
    console.log('edit', editData);
    genSpecsForm.setFieldsValue(editData);
  }, [editData, genSpecsForm]);

  useEffect(() => {
    console.log('selectedLaunch changed:', selectedLaunch);
    if (selectedLaunch) {
      console.log('selectedLaunch changed in:', selectedLaunch);
      const pageFromUrl = Number(searchParams.get('page') || '1');
      const pageSizeFromUrl = Number(searchParams.get('pageSize') || '10');
      setPagination({
        current: Number.isFinite(pageFromUrl) && pageFromUrl > 0 ? pageFromUrl : 1,
        pageSize:
          Number.isFinite(pageSizeFromUrl) && pageSizeFromUrl > 0
            ? pageSizeFromUrl
            : 10,
        total: 0,
      });
      getAllProducts(selectedLaunch);
      // resetSetting;
    }
  }, [selectedLaunch]);

  const columns = [
    {
      key: 'id',
      title: 'ID',

      render: (record) => {
        console.log(record);
        return (
          <div>
            {' '}
            {/* <a
              onClick={() => {
                toProductDetails({ record });
              }}
            >
              {record.id}
            </a> */}
            {record.id}
          </div>
        );
      },
    },
    {
      key: 'master_sku',
      title: 'Master SKU',
      dataIndex: 'master_sku',
    },
    {
      key: 'collection',
      title: 'Collection',
      dataIndex: 'collection',
    },
    {
      key: 'title',
      title: 'Title',
      dataIndex: 'title',
    },
    {
      key: 'handle',
      title: 'Handle',
      dataIndex: 'handle',
    },
    {
      key: 'launch_name',
      title: 'Launch Name',
      dataIndex: 'launch_name',
    },
    {
      key: 'cataloging_status',
      title: 'Status',
      dataIndex: 'cataloging_status',
    },
    {
      /*
      key: 'action',
      title: 'Action',
      render: (_, record) => {
        return (
          <div>
            <div className="ActionColumn">
              <EditOutlined
                style={{ color: 'black' }}
                onClick={() => toProductDetails({ record: record })}
              />
            </div>
          </div>
        );
      },
      */
    },
  ];

  const toPreviousPage = () => {
    navigate(-1);
  };

  const paginatedProducts = products.slice(
    (pagination.current - 1) * pagination.pageSize,
    pagination.current * pagination.pageSize,
  );

  if (isLoading) {
    return <Spin size="large" />;
  }

  return (
    <div>
      <Row gutter={[24, 24]}>
        <Col md={12} lg={8} sm={24} xs={24}>
          <div className="genBuyPlan">
            <Title>Generate Shopify Master Sheet</Title>
            <Divider />
            <Form
              form={genSpecsForm}
              layout="vertical"
              onFinish={GenerateSelectedSheets}
            >
              <div className="av">
                <Row gutter={[16, 16]}>
                  <Col md={24} lg={24} sm={24} xs={24}>
                    <Form.Item
                      label="Select Launch"
                      name="launchGen"
                      rules={[
                        {
                          required: true,
                          message: 'Launch is Required!',
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        onSearch={(value) => {
                          // console.log('searching...', value);
                        }}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={launchListOption}
                        onChange={handleLaunchChange}
                        defaultValue={launchListOption.filter(
                          (launchDetails) =>
                            launchDetails.value == selectedLaunch,
                        )}
                      />
                    </Form.Item>
                    {/**
                      // <Select
                    //   showSearch
                    //   onSearch={(value) => {
                    //     // console.log('searching...', value);
                    //   }}
                    //   placeholder="Select "
                    //   optionFilterProp="children"
                    //   filterOption={(input, option) =>
                    //     (option?.label ?? '')
                    //       .toLowerCase()
                    //       .includes(input.trim().toLowerCase())
                    //   }
                    //   filterSort={(optionA, optionB) => {
                    //     // Preserve 'Select' option at the top
                    //     if (optionA.value === null) return -1;
                    //     if (optionB.value === null) return 1;

                    //     return (optionA?.label ?? '')
                    //       .toLowerCase()
                    //       .localeCompare((optionB?.label ?? '').toLowerCase());
                    //   }}
                    //   options={launchListOption}
                    //   onChange={handleLaunchChange}
                    //   value={selectedLaunch}
                    //   style={{ width: '100%' }}
                    // />
                      
                      */}
                  </Col>
                </Row>
              </div>

              <div className="genBtn">
                <Button onClick={() => GenerateSelectedSheets()}>
                  Generate
                </Button>
                <Button onClick={() => resetSetting()}>Reset</Button>
              </div>

              <div className="sheeetGenerated">
                <ListOfItem data={filesCreatedList} />
              </div>
            </Form>
          </div>
        </Col>

        <Col md={12} lg={16} sm={24} xs={24}>
          <Button type="link" onClick={toPreviousPage}>
            Back
            <RollbackOutlined />
          </Button>
          <div className="tableSection">
            <Divider />
            <div className="table">
              <Table
                dataSource={paginatedProducts}
                columns={columns}
                pagination={{
                  current: pagination.current,
                  pageSize: pagination.pageSize,
                  total: pagination.total,
                  showSizeChanger: true,
                  pageSizeOptions: ['10', '20', '50'],
                }}
                onChange={handleTableChange}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default GenerateShopifyMasterSheet;
